module.exports = __webpack_public_path__ + "img/23.6148c2bd.png";